import { render, staticRenderFns } from "./burger.vue?vue&type=template&id=3d794c7b&lang=pug"
import script from "./burger.vue?vue&type=script&lang=js"
export * from "./burger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports